import React from "react";
import { SiTicktick } from "react-icons/si";
import cover from "../../assets/vitt-vichaar/cover.webp";
import img1 from "../../assets/vitt-vichaar/1.webp";
import img2 from "../../assets/vitt-vichaar/2.webp";
import img3 from "../../assets/vitt-vichaar/3.webp";
import img4 from "../../assets/vitt-vichaar/4.webp";
import img5 from "../../assets/vitt-vichaar/5.webp";
import img6 from "../../assets/vitt-vichaar/6.webp";

const cards = [
  {
    title: "Basic Banking",
    point1: "Types of bank accounts",
    point2: "Opening Savings acc & ATMs Info",
    point3: "Govt Banking Schemes",
    image: img1,
  },
  {
    title: "Investments",
    point1: "How to Invest",
    point2: "Need to Invest",
    point3: "Different types of investments",
    image: img2,
  },
  {
    title: "Schemes for Women Entrepreneurs",
    point1: "Mahila E - Haat & Mahila Udyam Nidhi",
    point2: "Annapurna Scheme",
    point3: "Stree Shakti Package & Udyogini",
    image: img3,
  },
  {
    title: "Basic Household Saving Habits",
    point1: "Benefits of Saving",
    point2: "Household budgeting",
    point3: "Saving tools",
    image: img4,
  },
  {
    title: "Digital Transactions",
    point1: "Digital Payment",
    point2: "Debit/Credit Card",
    point3: "UPI Payments",
    image: img5,
  },
  {
    title: "Understanding Traps & SHG",
    point1: "Debt trap",
    point2: "Emergency fund",
    point3: "Char. & Structure of Self Help Groups",
    image: img6,
  },
];

export default function Cards() {
  return (
    <>
      <div className="bg-[#257377]">
        <img src={cover} alt="" className="w-80 mx-auto block mb-[-60px]" />
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 text-left p-6 sm:pb-8 lg:pb-12 gap-6">
          {cards.map((card, index) => (
            <div
              key={index}
              className="shadow-md p-6 rounded-lg bg-white text-[#257377] font-semibold text-md relative border border-b-8 border-b-[#F5BB33] flex flex-col"
            >
              <img
                src={card.image}
                alt={card.title}
                className="w-16 h-16 hidden md:block absolute top-4 right-4 max-w-full"
              />
              <h2 className="text-lg font-bold mb-2 text-gray-600">
                {card.title}
              </h2>
              <p className="text-gray-600 flex items-center mb-2">
                <SiTicktick className="mr-2 text-green-600" />
                {card.point1}
              </p>
              <p className="text-gray-600 flex items-center mb-2">
                <SiTicktick className="mr-2 text-green-600" />
                {card.point2}
              </p>
              <p className="text-gray-600 flex items-center">
                <SiTicktick className="mr-2 text-green-600" />
                {card.point3}
              </p>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}
